import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import * as Styled from './ToggleableTextarea.styles';

import { Textarea } from '../Textarea/Textarea';

export const ToggleableTextarea = ({ onChange, label, showButtonText, hideButtonText, value, error, width, maxWidth, minWidth }) => {
    const [isTextareaVisible, setIsTextareaVisible] = useState(value.length > 0);

    const handleRemoveTextarea = (e) => {
        setIsTextareaVisible(false);
        onChange('');
    }

    return (
        <Styled.Wrapper width={width} maxWidth={maxWidth} minWidth={minWidth}>
            {isTextareaVisible ? 
            (
                <Styled.WrapperShown>
                    <Textarea label={label} value={value} onChange={onChange} error={error} />
                    <Styled.ButtonRemove onClick={handleRemoveTextarea} disableRipple>{hideButtonText}</Styled.ButtonRemove>
                </Styled.WrapperShown>
            ) :
            (
                <Styled.WrapperHidden>
                    <Styled.ButtonShow onClick={() => setIsTextareaVisible(true)}disableRipple>{showButtonText}</Styled.ButtonShow>
                </Styled.WrapperHidden>
            )}
        </Styled.Wrapper>
    );
};

Textarea.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
};
